import { Button } from '@/components/ui/button';
import { Grid3x3, List } from 'lucide-react';

interface ProductViewToggleProps {
  productView: 'grid' | 'list';
  onChange: (view: 'grid' | 'list') => void;
}

export function ProductViewToggle({ productView, onChange }: ProductViewToggleProps) {
  return (
    <div className="flex rounded-md border border-slate-200 bg-slate-50/80 p-0.5 gap-0.5">
      <Button
        size="sm"
        variant={productView === 'grid' ? 'default' : 'ghost'}
        onClick={() => onChange('grid')}
        className="h-7 gap-1 px-2 text-xs"
      >
        <Grid3x3 className="h-3.5 w-3.5" />
        <span>Grid</span>
      </Button>

      <Button
        size="sm"
        variant={productView === 'list' ? 'default' : 'ghost'}
        onClick={() => onChange('list')}
        className="h-7 gap-1 px-2 text-xs"
      >
        <List className="h-3.5 w-3.5" />
        <span>List</span>
      </Button>
    </div>
  );
}
